export const getUserLocale = () => {
  let locale

  if (window.navigator) {
    return window.navigator.userLanguage || window.navigator.language
  }

  return locale || 'en-us'
}
